import * as React from "react";
import { useState, useEffect } from "react";
import * as webHelpers from "../../../../../helpers/WebHelpers";
import "./styles.scss";
import TNCS from "../../../../../assets/terms.json";
import RTC from "../../../../../assets/rtc.json";
//@ts-ignore
import {Checkbox,CheckboxGroup,Input,Button,ButtonGroup,AlertIcon,Alert,AlertTitle,AlertDescription,Box,Flex,Text,FormControl,FormErrorMessage,FormLabel,Link, Heading} from "@chakra-ui/react";
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';

//@ts-ignore
import {Modal,ModalOverlay,ModalContent,ModalHeader,ModalFooter,ModalBody,ModalCloseButton,useDisclosure} from "@chakra-ui/react";

interface IRTCViewProps {
  jobNumber: string;
  isDamage: boolean;
  cb: Function;
  customerType: number;
}

export default function RTCView(props: IRTCViewProps) {
  const [termsChecked, setTermsChecked] = useState(false);
  const [damageChecked, setDamageChecked] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [ signee, setSignee ] = useState<string>("");
  const [isError, setIsError] = useState(false);
  const sendDataToGTM = useGTMDispatch();

  const handleSubmit = () => {
    if(signee !== "" && termsChecked && (props.isDamage === damageChecked)) { //If isDamage is false - then damageChecked will stay at default of false. 
      let signRTCPromise = webHelpers.postAsync("/api/sales/work/righttocancel/sign?job=" + props.jobNumber, { signee: signee });
      signRTCPromise.then(res => {
        if(res !== null) {
          props.cb();
          setIsError(false);
          sendDataToGTM({event: "rtc_signed", signeeName: signee});
        }
        else{
          alert('some server error occurred')
        }
      })
    }
    else {
      setIsError(true);
    }
  };

  const handleCheck = (e: { target: { checked: boolean }; }) => {
    setTermsChecked(e.target.checked);
    console.log(termsChecked);
  };

  const handleDamageCheck = (e: { target: { checked: boolean }; }) => {
    setDamageChecked(e.target.checked);
  };

  const onSigneeChange = (e: { target: { value: string }; }) => {
    setSignee(e.target.value);
  }

  return (
    <>
      <Flex mt={5} direction='column' w='full' borderWidth='2px' borderColor='gray.200' borderRadius='lg' p={2}>
        <Heading size='md' color='var(--Able-blue)'>Your Right to Cancel</Heading>
        {props.customerType == 0 &&
        
        <Box p={2} mt={2} borderColor='gray' borderWidth={1} borderRadius={5} maxHeight='210px' overflowY='auto'>
          <Text fontSize='sm'>{RTC.text}</Text>
          <Text fontSize='sm' mt={1}>{RTC.acknowledgement}</Text>
        </Box>
}
        <form onSubmit={handleSubmit}>
        <Flex ml={2} mr={2} mt={4}>
          <FormControl isInvalid={signee.length < 2} isRequired variant='floating'>
            <Input value={signee} onChange={onSigneeChange} placeholder=' '/>
            <FormLabel>Full Name</FormLabel>
            <FormErrorMessage ml={2}>Full Name is required</FormErrorMessage>
          </FormControl>
        </Flex>
        {props.customerType == 0 &&
        
        <Checkbox mt={2} ml={2} mr={2} checked={termsChecked} colorScheme='green' onChange={handleCheck}>
            I consent to these rights to cancellation terms and our terms and conditions. <Link onClick={onOpen} fontSize='sm' color='blue.500'>(view)</Link>
        </Checkbox>
}
        {props.customerType == 50 && 
              <Checkbox mt={2} ml={2} mr={2} checked={termsChecked} colorScheme='green' onChange={handleCheck}>
              I consent to recieve these products for the agreed upon price. <Link onClick={onOpen} fontSize='sm' color='blue.500'>(view)</Link>
              </Checkbox>              
        }
        {props.isDamage &&
        <Checkbox mt={2} ml={2} mr={2} checked={damageChecked} colorScheme='green' onChange={handleDamageCheck}>
          I acknowledge that the engineer has indicated the work may cause additional damage that is not liable to be repaired.
        </Checkbox>
        }

        <Flex direction='row' justifyContent='end' mr={2} mb={2}>
          <Button isDisabled={!termsChecked} colorScheme='green' onClick={handleSubmit} mt={2} type="submit">Confirm</Button>
        </Flex>
        </form>
      </Flex>

      <Modal size="5xl" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent className="overflow-y-scroll h-4/5 p-4">
          <ModalHeader>Terms and Conditions</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {TNCS.terms.split("\n").map(
              (
                line,
                index // split the text into lines  and map over them
              ) => (
                <>
                  <p key={index} className="text-sm text-slate-700">{line}</p>
                  <br />
                </>
              )
            )}
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* { isError ? (
          <Alert  status='warning'>
            <AlertIcon />
            <AlertTitle>Please Submit a Signee Name!</AlertTitle>
            <AlertDescription>Right to Cancellation cannot be accepted without doing so.</AlertDescription>
          </Alert>

      )  : <></>} */}

    </>
  );
}
